import React from "react";

export function StreakChip({ type, length, blip, size = "md", glow = false, testId }) {
  if (!type || !length) {
    return (
      <span data-testid={testId} className="inline-flex items-center justify-center px-2 py-1 text-xs uppercase tracking-wider text-zinc-500 border border-white/10 rounded-sm">
        —
      </span>
    );
  }
  const isWin = type === "W";
  const big = size === "lg";

  // Single-game blip = visually recessive
  if (blip) {
    return (
      <span
        data-testid={testId}
        className={`inline-flex items-center gap-0.5 font-mono-d ${big ? "text-base" : "text-xs"} px-1.5 py-0.5 rounded-sm border ${
          isWin ? "border-[#007AFF]/30 text-[#007AFF]/80" : "border-[#FF3B30]/30 text-[#FF3B30]/70"
        } bg-transparent`}
        title={`Single-game ${isWin ? "win" : "loss"} blip`}
      >
        <span className="opacity-60">·</span>
        {type}{length}
      </span>
    );
  }

  const winCls = `bg-[#007AFF] text-white font-bold`;
  const lossCls = `bg-transparent border-2 border-[#FF3B30] text-[#FF3B30] font-bold`;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center justify-center font-display tracking-wider rounded-sm ${
        big ? "text-2xl min-w-[56px] px-3 py-1.5" : "text-sm min-w-[36px] px-2 py-1"
      } ${isWin ? winCls : lossCls} ${glow ? (isWin ? "glow-win" : "glow-loss") : ""}`}
    >
      {type}{length}
    </span>
  );
}
